import { Box, Stack } from '@chakra-ui/layout';
import { FallbackProps } from 'react-error-boundary';

const ErrorFallback = (props: FallbackProps) => {
  return (
    <Stack>
      <Box>Error occurred.</Box>
      <Box>{props.error?.name}</Box>
      <Box>{props.error?.message}</Box>
    </Stack>
  );
};
export default ErrorFallback;
